import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"

import img from "./gic_ukas_2017.png"

const ISO9001 = () => {
  return (
    <Anchor href="http://www.ukas.com/" newTab>
      <Image src={img} alt="ISO9001" />
    </Anchor>
  )
}

export default ISO9001
